import React from "react";
import PropTypes from "prop-types";
import { useDispatch } from "react-redux";
import { useTranslation } from "react-i18next";
import { deleteUserAsync } from "@client.pages/Settings/reducer";
import useModal from "@client.hooks/useModal";
import DeleteUserModal from "./DeleteUserModal";
import { useDemo } from "@client.hooks/useDemo";

const DeleteButton = ({ user }) => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const { showModal } = useModal();
  const { withDemoCheck } = useDemo();

  const onDelete = () => {
    withDemoCheck(() => {
      let deleteModalRef = null;

      const handleDelete = async (deleteOptions) => {
        try {
          await dispatch(deleteUserAsync(deleteOptions));
          return { error: false };
        } catch {
          return { error: true };
        }
      };

      showModal({
        title: t("components.UserManagementContent.deleteUser"),
        contentClass: 'delete-user-modal-content',
        component: (
          <DeleteUserModal
            ref={(ref) => {
              deleteModalRef = ref;
            }}
            user={user}
            onDelete={handleDelete}
          />
        ),
        footerButtons: [
          {
            icon: "close",
            text: t("components.UserManagementContent.delete"),
            onClick: async () => {
              if (deleteModalRef && deleteModalRef.handleDelete) {
                return await deleteModalRef.handleDelete();
              }
              return Promise.resolve({ error: true });
            },
          },
        ],
      });
    });
  };

  return (
    <div onClick={onDelete} className="option delete">
      {t("components.UserManagementContent.GridManagementButtons.delete")}
    </div>
  );
};

DeleteButton.propTypes = {
  user: PropTypes.shape({
    id: PropTypes.string,
    email: PropTypes.string,
    firstName: PropTypes.string,
    lastName: PropTypes.string,
  }).isRequired,
};

export default DeleteButton;
